const FrmValidation = {
    error(frmValidate, key) {
        if (frmValidate.hasOwnProperty(key)) {
            return frmValidate[key].err;
        } else {
            return false;
        }
    },
    msg(frmValidate, key) {
        if (frmValidate.hasOwnProperty(key)) {
            return frmValidate[key].msg.la;
        } else {
            return '';
        }
    }
}

export default FrmValidation